__turbopack_context__.v({
  "className": "figtree_f7ad065e-module__EM4zeq__className",
  "variable": "figtree_f7ad065e-module__EM4zeq__variable",
});
